import { render, staticRenderFns } from "./AskIQButton.vue?vue&type=template&id=271677a7&scoped=true"
import script from "./AskIQButton.vue?vue&type=script&setup=true&lang=js"
export * from "./AskIQButton.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AskIQButton.vue?vue&type=style&index=0&id=271677a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271677a7",
  null
  
)

export default component.exports